import {
  fetchAgeGroups,
  createAgeGroup,
  updateAgeGroup,
  deleteAgeGroup,
  updateClassrooms,
} from './legup-age_groups.service';
import { deleteSchedule, updateSchedule } from './legup-schedules.service';

export default {
  namespaced: true,

  state: {
    ageGroups: [],
  },

  mutations: {
    setAgeGroups: (state, ageGroups) => {
      state.ageGroups = ageGroups.sort((a, b) => {
        if (a.minAge < b.minAge) return -1;
        if (a.minAge > b.minAge) return 1;
        return 0;
      });
    },
    setClassroomsByAgeGroup(state, { ageGroupId, classrooms }) {
      state.ageGroups = state.ageGroups.map((ageGroup) => {
        if (ageGroup.id === ageGroupId) {
          const newAgeGroup = { ...ageGroup };
          newAgeGroup.classrooms = classrooms;
          return newAgeGroup;
        }
        return ageGroup;
      });
    },
    addSchedule: (state, schedule) => {
      const idx = state.ageGroups.findIndex((ag) => ag.id === schedule.ageGroupId);
      state.ageGroups[idx].schedules.push(schedule);
    },
    updateSchedule: (state, schedule) => {
      const ageGroupIdx = state.ageGroups.findIndex((ag) => ag.id === schedule.ageGroupId);
      if (!!schedule.prevAgeGroupUpdated) {
        const oldAgeGroupId = schedule.prevAgeGroupUpdated;
        state.ageGroups[ageGroupIdx].schedules.push(schedule);
        const oldAgeGroupIdx = state.ageGroups.findIndex((ag) => ag.id === oldAgeGroupId);
        const scheduleIdx = state.ageGroups[oldAgeGroupIdx].schedules.findIndex((s) => s.id === schedule.id);
        state.ageGroups[oldAgeGroupIdx].schedules.splice(scheduleIdx, 1);
      } else {
        const scheduleIdx = state.ageGroups[ageGroupIdx].schedules.findIndex((s) => s.id === schedule.id);
        state.ageGroups[ageGroupIdx].schedules[scheduleIdx] = schedule;
      }
    },
    deleteSchedule: (state, { scheduleId, ageGroupId }) => {
      const ageGroupIdx = state.ageGroups.findIndex((ag) => ag.id === ageGroupId);
      const scheduleIdx = state.ageGroups[ageGroupIdx]
        .schedules.findIndex((s) => s.id === scheduleId);
      state.ageGroups[ageGroupIdx].schedules.splice(scheduleIdx, 1);
    },
  },

  getters: {
    ageGroupClassrooms: (state) => (ageGroupId) => {
      const classrooms = state.ageGroups.find(
        (ageGroup) => ageGroup.id === ageGroupId,
      )?.classrooms || [];

      return classrooms.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },
  },

  actions: {
    async fetchAgeGroups({ commit, dispatch }, centerId) {
      try {
        const ageGroups = await fetchAgeGroups(centerId);
        commit('setAgeGroups', ageGroups);
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not fetch programs.', error }, { root: true });
        throw new Error(error);
      }
    },

    async createAgeGroup({ dispatch }, { centerId, ageGroup }) {
      try {
        await createAgeGroup(centerId, ageGroup);
        dispatch('notifications/addToastSuccess', { text: 'Program has been created.' }, { root: true });
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not create program.', error }, { root: true });
        throw new Error(error);
      }
    },

    async updateAgeGroup({ dispatch }, ageGroup) {
      try {
        await updateAgeGroup(ageGroup.id, ageGroup);
        dispatch('notifications/addToastSuccess', { text: 'Your program has been updated.' }, { root: true });
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not update program.', error }, { root: true });
        throw new Error(error);
      }
    },

    async deleteAgeGroup({ dispatch }, id) {
      try {
        await deleteAgeGroup(id);
        dispatch('notifications/addToastSuccess', { text: 'Your program has been deleted.' }, { root: true });
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not delete program.', error }, { root: true });
        throw new Error(error);
      }
    },

    async updateClassrooms({ commit, dispatch }, { ageGroupId, classrooms }) {
      try {
        const response = await updateClassrooms(ageGroupId, classrooms);
        const newClassrooms = response.classrooms.map((classroom) => (
          { id: classroom.classroomId, name: classroom.name }));
        commit('setClassroomsByAgeGroup', { ageGroupId, classrooms: newClassrooms });
        dispatch('notifications/addToastSuccess', { text: 'Your classrooms have been saved.' });
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not update classrooms', error }, { root: true });
      }
    },
  },
};
